<template>
  <main class="narrow-view">
    <h1 class="view-full-span">
      {{ $t('general.greeting', { name: $t('general.bowler') }) }}
    </h1>

    <div class="view-full-span">
      {{ $t('general.login-description') }}
    </div>

    <LoginForm />
  </main>
</template>

<script lang="ts" setup>
import LoginForm from '@/components/forms/LoginForm'
</script>
